import { TipoTenantEnum } from "core/resources/enums/tenant";

export function getTenantTipoName(tipo: TipoTenantEnum | null) {
  if (!tipo) {
    return null;
  }

  if (tipo === TipoTenantEnum.EmpresaComum) {
    return "Empresa";
  }

  if (tipo === TipoTenantEnum.Condominio) {
    return "Condomínio";
  }

  if (tipo === TipoTenantEnum.Administradora) {
    return "Administradora";
  }

  if (tipo === TipoTenantEnum.Construtora) {
    return "Construtora";
  }

  if (tipo === TipoTenantEnum.Imobiliaria) {
    return "Imobiliária";
  }

  if (tipo === TipoTenantEnum.Incorporadora) {
    return "Incorporadora";
  }

  return null;
}
